import React, { useCallback } from 'react'
import { Modal } from 'reactstrap'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Dialogs'
import context from '@/context'
import ErrorBoundary from '@/components/ErrorBoundary'

function mapStateToProps (state) {
  const dialogs = state.dialogs.visibleStack.map(id => ({ dialogUid: id, options: state.dialogs.dialogs[id] }))
  return { dialogs }
}

const mapDispatchToProps = {
  closeDialog: actionCreators.closeDialog
}

@connect(mapStateToProps, mapDispatchToProps)
class AppDialog extends React.Component {
  componentDidMount () {
    document.addEventListener('keydown', this.handleKeyDown, false)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.handleKeyDown, false)
  }

  handleKeyDown = e => {
    if (e.keyCode === 27) { // escape key
      const { dialogs, closeDialog } = this.props
      if (dialogs.length > 0) {
        closeDialog(dialogs[0].dialogUid)
      }
    }
  }

  render () {
    const { dialogs, closeDialog } = this.props
    return dialogs.map(props => <DialogWrapper key={props.dialogUid} {...props} closeDialog={closeDialog} />)
  }
}

const DialogWrapper = React.memo(function DialogWrapper ({ closeDialog, ...props }) {
  const { dialogUid, options } = props
  const { dialogType, ...customOptions } = options
  const onClose = useCallback(() => closeDialog(dialogUid), [closeDialog, dialogUid])
  const onAction = useCallback(e => handleAction(e, customOptions.onAction, onClose), [customOptions.onAction, onClose])

  if (!dialogUid || !options) return null
  const dialog = context.dialogs[dialogType]
  if (!dialog || !dialog.component) return null
  const { component, ...defaultProps } = dialog
  const Dialog = component
  const [modalProps, dialogProps] = prepareOptions(defaultProps, customOptions)
  return (
    <Modal isOpen {...modalProps}>
      <ErrorBoundary>
        <Dialog
          dialogUid={dialogUid}
          {...dialogProps}
          closeDialog={onClose}
          onAction={onAction} />
      </ErrorBoundary>
    </Modal>
  )
})

function handleAction (e, onAction, close) {
  if (typeof onAction === 'function') {
    const result = onAction(e)
    if (result instanceof Promise) {
      // eslint-disable-next-line promise/catch-or-return
      result.then(x => x !== false && close())
      return
    } else {
      result !== false && close()
    }
  }
  close()
}

function prepareOptions (defaultOptions, customOptions) {
  const props = { ...defaultOptions, ...customOptions }
  const { modalProps, ...dialogProps } = props
  return [modalProps, dialogProps]
}

export {
  AppDialog
}



// WEBPACK FOOTER //
// ./src/components/appDialog/appDialog.js